import BasePropertyView from 'BasePropertyView.js';
import _template from 'properties/main/table-rows.ejs';
import TextUtil from 'util/TextUtil.js';
import undoService from 'UndoService';

class MainTableRowsView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'keydown input[type=text]' : 'validateNumber',
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    validateNumber(e){
        TextUtil.validatePositiveNumeric(e);
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.value;
        let oldVal  = this.model.get(propName);
        if(propName === "maxRows"){
            if(propVal !== "") {
                propVal = parseInt(propVal) > 400000 ? "400000" : propVal
            }
            else{
                propVal="0";
            }
        }
        this.model.set( propName, propVal );

        undoService.add({
            undo: () =>{
                this.model.set( propName, oldVal );
            },
            redo:() => {
                this.model.set( propName, propVal );
            }
        });
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }


}

export default MainTableRowsView;